import { render, staticRenderFns } from "./OrderPuescPopup.vue?vue&type=template&id=0c600fa4&"
import script from "./OrderPuescPopup.vue?vue&type=script&lang=js&"
export * from "./OrderPuescPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports